import React, { Fragment, useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { UserContext } from 'providers/user.provider';
import { useDispatch, useSelector } from 'react-redux';
import { compose } from 'redux';
import injectSaga from 'redux-utils/injectSaga';
import injectReducer from 'redux-utils/injectReducer';
import WithApa from 'newComponents/WithApa/WithApa';
import { Modal, Button } from 'cvlib';
import { GetRegion } from 'constants.js';
import { actions as getUserInfoActions } from 'action-creators/user/getUserInfo';
import { setMetricsEvent } from 'action-creators/metrics';
import Constants from 'containers/User/components/Form/facebook.constants';
import { FaChevronLeft } from 'react-icons/fa';
import { apiCall, updateSwaggerManager } from 'api/index';
import Metrics from 'services/metrics';
import {
  setIsEmailRegister,
  setUserInfo,
} from 'containers/UserSuspendedModal/redux/actions/setUserInfo.action';
import ModalError from './components/FacebookErrorModal';
import saga from '../User/saga';
import reducer from '../User/reducer';
import { actionUserLogInEmail, actionFacebook } from '../User/actions';
import { getLoginState } from '../User/selectors/loginEmail';
import './Login.scss';

import { METRICS as m, TYPES_LOGIN as t } from './constants';
import {
  EmailLoginForm,
  PasswordLoginForm,
  ForgotPassword,
} from './components';
import { redirect as appleRedirect } from './components/AppleIdButton';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { triggerBanner } from 'reducers/videoBanner/videoBanner.actions';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import getQueryParameter from 'utils/nav/getQueryParameter';
import { getRegion } from 'utils/Region';
import { getHboCommunicationPostLoginPath } from 'containers/HboCommunication/utils/getHboCommunicationPostLoginPath';
import { isProfileSelectionPending } from 'containers/HboCommunication/utils/isProfileSelectionPending';
import Metrics from 'services/metrics';
import { useMetrics } from 'hooks/metrics/useMetrics';

window.Fragment = Fragment;

const selectMetadata = state => state.metadata;

const LandingPage = ({ asset, translations }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const { buildMetricsEvent, sendMetricsEvent } = useMetrics();
  const STEPS = {
    EMAIL_LOGIN_FORM: 0,
    PASSWORD_LOGIN_FORM: 1,
    FORGOT_PASSWORD_SCREEN: 2,
  };

  const SUBMIT_TYPES = {
    previous: 'previous',
    next: 'next',
    register: 'register',
    forgotPassword: 'forgotPassword',
    validateLoginEmail: 'validateLoginEmail',
    login: 'login',
    cancel: 'cancel',
    loginemail: 'loginemail',
    facebookLogin: 'facebookLogin',
  };

  const {
    Onboarding_IniciaSesionRCU_Form_Logo_Mail: claroAdLogo,
    landing_head_logoClarovideo: cvLogo,
    landing_access_background: backgroundImage,
    Onboarding_IniciaSesionRCU_Form_Background_Mail: claroAdBackground,
  } = asset;
  const initialStep =
    params.get('reset_password') !== null
      ? STEPS.FORGOT_PASSWORD_SCREEN
      : STEPS.EMAIL_LOGIN_FORM;
  const [activeStep, setActiveStep] = useState(initialStep);
  const [email, setEmail] = useState();
  const [emailValid, setEmailValid] = useState(true);
  const [isLogingInWithFacebook, setIsLogingInWithFacebook] = useState(false);
  const [showFacebookError, setShowFacebookError] = useState(false);
  const [messageFacebookError, setMessageFacebookError] = useState('');
  const metadata = useSelector(selectMetadata);
  const dispatch = useDispatch();
  const claroAdEnable = useSelector(
    selectMetadataKeyByRegion('cv_advertising_config'),
  );
  const profilesConfig = useSelector(selectMetadataKeyByRegion('profiles_config'));
  const { firstNode } = useMenuRedirect();
  const { login } = useContext(UserContext);
  const { loading, error } = useSelector(getLoginState);

  const mountScript = () => {
    const { facebook_appkey } = metadata;
    const script = document.createElement('script');
    script.src = Constants.FACEBOOK_SCRIPT_SDK_SOURCE;
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.id = Constants.FACEBOOK_SCRIPT_ID;
    document.body.appendChild(script);

    window.fbAsyncInit = () => {
      window.FB.init({
        appId: facebook_appkey,
        cookie: true,
        xfbml: true,
        version: Constants.FACEBOOK_SCRIPT_API_VERSION,
      });

      window.FB.getLoginStatus(() => {});
    };
  };

  useEffect(() => {
    mountScript();
    return () => {
      const element = document.getElementById('fb-script');
      element.parentNode.removeChild(element);
    };
  }, []);

  useEffect(
    () => {
      if (location?.action === 'POP' && !location?.state) {
        if (!(params.get('reset_password') !== null)) {
          processSubmitAction(SUBMIT_TYPES?.loginemail);
        }
      }
    },
    [location],
  );
  const sendMetrics = params => {
    dispatch(
      setMetricsEvent({
        tagManager: {
          ...params,
        },
      }),
    );

    dispatch(
      setMetricsEvent({
        type: m?.EXECUTOR,
        success: true,
      }),
    );
  };

  const handleLogin = async pass => {
    sessionStorage.setItem('hasFetchNav', false);
    let success = false;
    try {
      await new Promise((resolve, reject) => {
        dispatch(
          actionUserLogInEmail({
            email,
            password: pass,
            login,
            claroLiteConfig: claroAdEnable?.enable || false,
            callback: response => {
              if (response.error || response.code) {
                reject(response?.error || response?.code);
                success = false;
              } else {
                resolve(response.data);
                success = true;
              }
            },
          }),
        );
      });

      return success;
    } catch (error) {
      return false;
    }
  };

  const handleChatClicked = () => {
    window.open(translations.telmex_chat_link);
  };

  const apiFacebookHandler = response => {
    if (response.status === 'connected') {
      window.FB.api(Constants.LOGIN_ENDPOINT, userData => {
        const params = {
          usersocial_id: userData.id,
          socialnetwork: 'facebook',
          login,
          setShowFacebookError,
          setMessageFacebookError,
        };
        dispatch(actionFacebook(params));
        setIsLogingInWithFacebook(false);
      });
    } else {
      setIsLogingInWithFacebook(false);
    }
  };

  const handleFacebookLogin = () => {
    setIsLogingInWithFacebook(true);
    sendMetrics({
      event: m?.EVENT?.LOGIN,
      eventCategory: m?.CATEGORY?.LANDING,
      eventAction: m?.ACTION?.LOGIN,
      eventLabel: t?.FACEBOOK + m?.LABEL?.LOGIN_NEXT,
    });
    window.FB.getLoginStatus(response => {
      if (response?.status === 'connected') {
        apiFacebookHandler(response);
      } else {
        setIsLogingInWithFacebook(true);
        window.FB.login(apiFacebookHandler, {
          scope: Constants.PERMISSION_SCOPE,
        });
      }
    });
  };

  const processSubmitAction = async (submitAction, values) => {
    switch (submitAction) {
      case SUBMIT_TYPES?.previous:
        setActiveStep(activeStep - 1);
        break;
      case SUBMIT_TYPES?.next:
        setActiveStep(activeStep + 1);
        break;
      case SUBMIT_TYPES?.cancel:
        dispatch(setIsEmailRegister(false));
        dispatch(setUserInfo(''));
        localStorage.removeItem('getUserInfo');
        localStorage.removeItem('isEmailRegister');

        const anonymousUserComeFromPlayer = params.get(
          'anonymousUserComeFromPlayer',
        );
        if (anonymousUserComeFromPlayer) {
          return navigate(
            `/${GetRegion()}/vcard/homeuser/${params.get(
              'title_uri',
            )}/${params.get('group_id')}`,
          );
        }

        const pageToRedirect = claroAdEnable?.enable ? firstNode : 'landing';

        navigate(`/${GetRegion()}/${pageToRedirect}`, { ...location });
        break;
      case SUBMIT_TYPES.register:
        navigate(`/${GetRegion()}/register${location?.search}`, {
          ...location,
        });
        break;
      case SUBMIT_TYPES?.loginemail:
        setActiveStep(STEPS?.EMAIL_LOGIN_FORM);
        break;
      case SUBMIT_TYPES?.forgotPassword:
        setActiveStep(STEPS?.FORGOT_PASSWORD_SCREEN);
        break;
      case SUBMIT_TYPES?.login: {
        if (params.get('anonymousUserComeFromPlayer')) {
          localStorage.setItem('anonymousUserComeFromPlayer', true);
        }
        if (params.get('urlVcard')) {
          localStorage.setItem('urlVcard', true);
        }
        const succeeded = await handleLogin(values?.password);

        if (succeeded) {
          if (getQueryParameter('addFavorite') === 'true') {
            localStorage.setItem('addToFavorite', true);
          }
          localStorage.removeItem('defaultLiveChannel');
          dispatch(triggerBanner('login'));
        if(!params.get('linkworkflowstart')){
          // Entro por /activacionhbo sin sesion: directo a esa ruta, sin pasar por Home. Si el
          // selector de perfil aun se mostrara no se salta: lo redirige LaunchRedirect al elegirlo
          const hboCommunicationPath = getHboCommunicationPostLoginPath({
            profileSelectionPending: isProfileSelectionPending(profilesConfig),
          });

          navigate(
            hboCommunicationPath ||
              `/${GetRegion()}/${firstNode}?login=true${location?.search || ''}`,
            {
              ...location.state,
              replace: true,
            },
          );

        }

        }
        break;
      }
      case SUBMIT_TYPES.validateLoginEmail: {
        dispatch(
          getUserInfoActions.getUserInfo({
            email: values?.emailLogin,
          }),
        )
          .then(unregisteredUser => {
            const getUserInfo = JSON.parse(
              localStorage.getItem('getUserInfo') || '{}',
            );
            const regionFromStartHeaderInfo = JSON.parse(
              localStorage.getItem('startHeaderInfoResponse') || '{}',
            );
            const isEmailRegister = !unregisteredUser;
            Metrics.newRelicEvent({
              event: 'login_validate_email',
              user_id: getUserInfo?.id_usuario,
              is_email_register: isEmailRegister,
            });
            dispatch(setUserInfo(getUserInfo));
            dispatch(setIsEmailRegister(isEmailRegister));
            const apiParams = {
              user_id: getUserInfo?.id_usuario,
              user_token: getUserInfo?.token,
              region:
                regionFromStartHeaderInfo?.response?.region || getRegion(),
            };
            if (getUserInfo && getUserInfo?.region_nombre) {
              apiParams.region = getUserInfo?.region_nombre;
            }

            updateSwaggerManager(apiCall, apiParams);
            localStorage.setItem('isEmailRegister', isEmailRegister);

            if (!unregisteredUser) {
              setActiveStep(STEPS?.PASSWORD_LOGIN_FORM);
              navigate(`${location?.pathname}${location?.search}`, {
                state: { page_id: 2, ...location.state },
              });
              setEmailValid(true);
            } else {
              setEmailValid(false);
            }
          })
          .catch(() => {
            setEmailValid(false);
          });
        break;
      }
      case SUBMIT_TYPES.facebookLogin:
        handleFacebookLogin();
        break;
      default:
        throw new Error(`Submit action ${submitAction} not supported`);
    }
  };

  const getActiveComponent = () => {
    switch (activeStep) {
      case STEPS.FORGOT_PASSWORD_SCREEN:
        return (
          <ForgotPassword
            email={email}
            onCancelClicked={() => processSubmitAction(SUBMIT_TYPES?.cancel)}
            translations={translations}
          />
        );
      case STEPS.EMAIL_LOGIN_FORM:
        return (
          <EmailLoginForm
            metadata={metadata}
            isLogingInWithFacebook={isLogingInWithFacebook}
            translations={translations}
            onTermsClicked={() => {
              processSubmitAction(SUBMIT_TYPES.terms);
            }}
            onCancelClicked={() => {
              sendMetrics({
                event: m?.EVENT.LOGIN,
                eventCategory: m?.CATEGORY?.LANDING,
                eventAction: m?.ACTION?.LOGIN,
                eventLabel: t?.EMAIL + m?.LABEL?.LOGIN_CANCEL,
              });
              processSubmitAction(SUBMIT_TYPES?.cancel);
            }}
            onFacebookClicked={() => {
              sendMetrics({
                event: m?.EVENT?.LOGIN,
                eventCategory: m?.CATEGORY?.LANDING,
                eventAction: m?.ACTION?.LOGIN,
                eventLabel: m?.LABEL?.LOGIN_FACEBOOK,
              });
              processSubmitAction(SUBMIT_TYPES?.facebookLogin);
            }}
            onAppleClicked={async () => {
              await sendMetrics({
                event: m?.EVENT.LOGIN,
                eventCategory: m?.CATEGORY?.LANDING,
                eventAction: m?.ACTION?.LOGIN,
                eventLabel: m?.LABEL?.LOGIN_APPLE,
              });
              appleRedirect('login');
            }}
            onNextClicked={values => {
              setEmail(values.emailLogin);
              processSubmitAction(SUBMIT_TYPES?.validateLoginEmail, values);
              sendMetrics({
                event: m?.EVENT?.LOGIN,
                eventCategory: m?.CATEGORY?.LANDING,
                eventAction: m?.ACTION?.LOGIN,
                eventLabel: t?.EMAIL + m?.LABEL?.LOGIN_NEXT,
              });
            }}
            onRegisterClicked={() => {
              sendMetrics({
                event: m?.EVENT?.LOGIN,
                eventCategory: m?.CATEGORY?.LANDING,
                eventAction: m?.ACTION?.LOGIN,
                eventLabel: m?.LABEL?.SING_UP,
              });
              processSubmitAction(SUBMIT_TYPES.register);
            }}
            emailValid={emailValid}
            onChatClicked={handleChatClicked}
            clearValidEmailError={() => {
              setEmailValid(true);
            }}
          />
        );
      case STEPS.PASSWORD_LOGIN_FORM:
        return (
          <PasswordLoginForm
            translations={translations}
            onPasswordRecoveryClicked={() => {
              const event = buildMetricsEvent('interaction_forgotten_password', {
                content_section: 'inicia sesion',
                interaction_type:
                  translations?.login_password_option_button_passwordRecovery.toLowerCase()
                  || 'obtener nueva contraseña',
                modulo_name: 'nueva contraseña',
              });

              sendMetricsEvent(event);
              processSubmitAction(SUBMIT_TYPES?.forgotPassword);
            }}
            isLoading={loading}
            error={error}
            onCancelClicked={() => {
              sendMetrics({
                event: m?.EVENT?.LOGIN,
                eventCategory: m?.CATEGORY?.LANDING,
                eventAction: m?.ACTION?.LOGIN,
                eventLabel: t?.EMAIL + m?.LABEL?.LOGIN_PASSWORD_CANCEL,
              });
              processSubmitAction(SUBMIT_TYPES.cancel);
            }}
            onNextClicked={values => {
              sendMetrics({
                event: m?.EVENT?.LOGIN,
                eventCategory: m?.CATEGORY?.LANDING,
                eventAction: m?.ACTION?.LOGIN,
                eventLabel: t?.EMAIL + m?.LABEL?.LOGIN_PASSWORD_NEXT,
              });
              processSubmitAction(SUBMIT_TYPES?.login, values);
            }}
          />
        );
      default:
        throw new Error(`Step ${activeStep} not supported`);
    }
  };

  return (
    <>
      <header className="loginHeader">
        <a
          className="logoHeader"
          href={`/${GetRegion()}/landing${location?.search}${location?.hash}`}
          onClick={event => {
            event.preventDefault();
            navigate(`/${GetRegion()}/landing${location?.search}`, {
              ...location,
            });
          }}
        >
          <img
            src={claroAdEnable?.enable ? claroAdLogo : cvLogo}
            alt="logo"
            className={claroAdEnable?.enable ? 'claroAdLogo' : ''}
          />
        </a>
        <Button className="loginBackButton" onClick={() => navigate(-1)}>
          <FaChevronLeft className="chevron" />
          {translations.top_head_option_button_back}
        </Button>
      </header>
      <Modal isOpen={showFacebookError} classNames={[]}>
        <ModalError
          error_message={messageFacebookError}
          translations={translations}
          asset={asset}
          onCloseModal={() => setShowFacebookError(false)}
        />
      </Modal>
      <div
        className="background"
        style={{
          backgroundImage: `url(${
            claroAdEnable?.enable ? claroAdBackground : backgroundImage
          })`,
        }}
      />
      <div className="loginPage">
        <div>{getActiveComponent()}</div>
      </div>
    </>
  );
};

LandingPage.propTypes = {
  asset: PropTypes.object,
  onSubmit: PropTypes.func,
  onValidateEmail: PropTypes.func,
  translations: PropTypes.object,
};

const withSaga = injectSaga({ key: 'sso', saga });
const withReducer = injectReducer({ key: 'sso', reducer });

export default compose(
  withSaga,
  withReducer,
  WithApa,
)(LandingPage);
